// extracted by mini-css-extract-plugin
export default {"main":"styles_main__980aY","paper":"styles_paper__aTJ64","flexColumnSearch":"styles_flexColumnSearch__y4dgW"};